















import Vue from 'vue'
import { bus } from '../main'

import { Category } from '@/enums/category'

export default Vue.extend({
  data: () => ({
    search: ''
  }),
  methods: {
    filterActive() {
      this.$store.commit('categories/setCurrentCategory', Category.ALL)
    },
    filteringProducts() {
      this.search ? bus.$emit('filteringProducts', this.search.toLowerCase()) : bus.$emit('filteringProducts', '')
    }
  },
  mounted() {
    this.search = ''
    bus.$emit('filteringProducts', this.search)
  }
})
